 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"54ca0fb2b2416e3ae8ae349216903b763ff7d7fa","2":"e036212fccbab1174514729cc04cd23cdd92d71b","3":"eef70ec7ccdd9138444974fb462ab0e21dfaf6a2","4":"2c32dae14849a4f972874995451b6f57468ad597","5":"90f032246d4cdcf1d65eb1cf45f37ed8f593e782","6":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","7":"0621d8b58401fbbb4648cde9e41b980a21cfd385","8":"45b8fa8f769eeaf30dce263ad16a43012959eb36","9":"4a2c3bec25065dd2fdea912623f4dd70707c247a","10":"c6a2b77176a3bc3bec1b47526d84d42cd52f595b","11":"e9a0828a5d05114d8b38e47f15dd66585fc04534","12":"f54b42984bfe4d114461fcea2710af414ac1fe74","13":"framework","14":"7490bd49aa53622910970b252a264e0dd9ced745","15":"fd113b4cd44afc312952b5152606df4c80fa1a9f","19":"component---src-pages-404-jsx","20":"component---src-pages-about-jsx","21":"component---src-pages-accessibility-index-jsx","22":"component---src-pages-accessibility-statement-jsx","23":"component---src-pages-accolades-jsx","24":"component---src-pages-alternative-index-jsx","25":"component---src-pages-black-friday-dear-manager-jsx","26":"component---src-pages-black-friday-index-jsx","27":"component---src-pages-calculator-jsx","28":"component---src-pages-case-studies-jsx","29":"component---src-pages-color-contrast-jsx","30":"component---src-pages-create-workspace-jsx","31":"component---src-pages-css-3-d-transform-examples-index-jsx","32":"component---src-pages-css-specificity-calculator-jsx","33":"component---src-pages-dear-manager-jsx","34":"component---src-pages-disclaimer-jsx","35":"component---src-pages-docs-changelog-jsx","36":"component---src-pages-docs-faq-jsx","37":"component---src-pages-docs-index-jsx","38":"component---src-pages-docs-ui-overview-jsx","39":"component---src-pages-download-jsx","40":"component---src-pages-experimental-web-platform-features-jsx","41":"component---src-pages-exported-panes-jsx","42":"component---src-pages-github-students-jsx","43":"component---src-pages-index-jsx","44":"component---src-pages-integrations-index-jsx","45":"component---src-pages-integrations-jetbrains-webstorm-jsx","46":"component---src-pages-integrations-markerio-jsx","47":"component---src-pages-integrations-toybox-systems-jsx","48":"component---src-pages-integrations-tumult-hype-jsx","49":"component---src-pages-integrations-tumult-whisk-jsx","50":"component---src-pages-legal-jsx","51":"component---src-pages-newsletter-jsx","52":"component---src-pages-og-screenshot-jsx","53":"component---src-pages-opener-jsx","54":"component---src-pages-portal-index-jsx","55":"component---src-pages-pricing-jsx","56":"component---src-pages-privacy-jsx","57":"component---src-pages-product-tour-jsx","58":"component---src-pages-quality-assurance-index-jsx","59":"component---src-pages-resources-jsx","60":"component---src-pages-responsive-design-glossary-jsx","61":"component---src-pages-responsive-website-test-jsx","62":"component---src-pages-screenshot-comparison-jsx","63":"component---src-pages-site-quality-index-jsx","64":"component---src-pages-social-media-previews-index-jsx","65":"component---src-pages-special-offers-jsx","66":"component---src-pages-support-index-jsx","67":"component---src-pages-syntax-jsx","68":"component---src-pages-tailwindcss-jsx","69":"component---src-pages-testimonials-jsx","70":"component---src-pages-thanks-jsx","71":"component---src-pages-visualize-browser-sizes-jsx","72":"component---src-templates-blog-list-jsx","73":"component---src-templates-doc-jsx","74":"component---src-templates-post-jsx","75":"component---src-templates-term-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"ae379e001f0699e9cfbd","2":"d1ee141440eb34de0bde","3":"4dca11d9e6f0a18bbb26","4":"8a50615bc752d1273f48","5":"48a2e2154c258c998ea6","6":"5bcd3926778d3cbed9fa","7":"e3a3f4a7573b5ee59591","8":"9b8a98fb38b16a5c7ac6","9":"ae0f1b8b7dc023d4685a","10":"bff76e08a440b84ac594","11":"99ced224b35a92bf44dd","12":"7926e00e6ed7fa314542","13":"4d2271910e950a98f200","14":"dc49d60845bdf5e5be37","15":"66eed85d68c83c64617b","17":"ffdb6f2c66f858d94e86","19":"b4eb345fa91d7a08a210","20":"1e969c6f2252dc4e058e","21":"2cb0385d9e44472fb7e4","22":"eef801f03774a19d4d8d","23":"91bfe67decf946adf283","24":"e30d9e18c32c3d02cad5","25":"ef270b5d5a048adf1396","26":"1262d847a256240e5800","27":"0aa431fcfc14595c5897","28":"9d4ab742a32e1d40b8f1","29":"b790ab73047ce044e6ff","30":"26fb49af3305ce4f0704","31":"0ac7fa583df9d1f0931b","32":"308e46950d52991828a1","33":"6ace33fe75034930704a","34":"dac6c845d64a24b6b57c","35":"8872b8b5cf974cb2f3db","36":"a18c973602cd9c0b8528","37":"233991f41d92fe5c7499","38":"9a211ed0d4fcfdfcfb02","39":"1c32b4e7dc223708b2ce","40":"65486fa2a56395b8b103","41":"323f535db2e1db6f5d44","42":"2bd01c499cf60bf4fbf6","43":"2de8c0dcfa56ea5d2d5d","44":"5bfbe51e64657ebbdedf","45":"c939db536680054c2147","46":"e137ed456a7ba288bb9a","47":"b0dc8360d95166072728","48":"d09e81b2abf7ae25f797","49":"07d593507f3e342b62d1","50":"e3723f022a4338aec453","51":"d378a0398ffc2eaaa72d","52":"ae3bc39229ef311c97ea","53":"482f74c397bd152e2daf","54":"17069acdeb4547baf59b","55":"20e3f64399beb3d001dd","56":"466f87aba4ae921bb3a1","57":"f9f4714d98ac66743041","58":"555314f2342fce996fc4","59":"182eb728eef89e2e73cc","60":"3d92f29a6386c200313e","61":"2d552b6c7ba57aa12a23","62":"2591b55d4f0583ebd9e9","63":"b3411ab14c903b70cc14","64":"9fd89a7f7ae83fad4169","65":"48f5bdf393fae20ab3a3","66":"3e8aa024486ee631a492","67":"9e390c5ec8147ae54349","68":"960fde6f9f39672a8ff4","69":"b94988a081e7b204f38b","70":"df750eee6aaabdde2861","71":"2a3c45a4a24a0d0fad5d","72":"c73d883d724cd305d893","73":"c598ddfda1c1945f171c","74":"9182751a5d67fbeee0b4","75":"e93845c8aed73bd285eb","77":"74b49508864cb6ee741f","78":"713c72510c202d5d5b90","79":"08f0d6725195c97ef40d","80":"469456b661f0faa8400b","81":"070d41972c44ab2e2992","82":"7e1c5cf6962f17a6a1df","83":"f8f149c09ef358d34a61","84":"91ab9857d27816cc1a6b","85":"d739c050ffde958105d3","86":"ee33e1197ac48b0aad83"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"54ca0fb2b2416e3ae8ae349216903b763ff7d7fa","2":"e036212fccbab1174514729cc04cd23cdd92d71b","3":"eef70ec7ccdd9138444974fb462ab0e21dfaf6a2","4":"2c32dae14849a4f972874995451b6f57468ad597","5":"90f032246d4cdcf1d65eb1cf45f37ed8f593e782","6":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","7":"0621d8b58401fbbb4648cde9e41b980a21cfd385","8":"45b8fa8f769eeaf30dce263ad16a43012959eb36","9":"4a2c3bec25065dd2fdea912623f4dd70707c247a","10":"c6a2b77176a3bc3bec1b47526d84d42cd52f595b","11":"e9a0828a5d05114d8b38e47f15dd66585fc04534","12":"f54b42984bfe4d114461fcea2710af414ac1fe74","13":"framework","14":"7490bd49aa53622910970b252a264e0dd9ced745","15":"fd113b4cd44afc312952b5152606df4c80fa1a9f","19":"component---src-pages-404-jsx","20":"component---src-pages-about-jsx","21":"component---src-pages-accessibility-index-jsx","22":"component---src-pages-accessibility-statement-jsx","23":"component---src-pages-accolades-jsx","24":"component---src-pages-alternative-index-jsx","25":"component---src-pages-black-friday-dear-manager-jsx","26":"component---src-pages-black-friday-index-jsx","27":"component---src-pages-calculator-jsx","28":"component---src-pages-case-studies-jsx","29":"component---src-pages-color-contrast-jsx","30":"component---src-pages-create-workspace-jsx","31":"component---src-pages-css-3-d-transform-examples-index-jsx","32":"component---src-pages-css-specificity-calculator-jsx","33":"component---src-pages-dear-manager-jsx","34":"component---src-pages-disclaimer-jsx","35":"component---src-pages-docs-changelog-jsx","36":"component---src-pages-docs-faq-jsx","37":"component---src-pages-docs-index-jsx","38":"component---src-pages-docs-ui-overview-jsx","39":"component---src-pages-download-jsx","40":"component---src-pages-experimental-web-platform-features-jsx","41":"component---src-pages-exported-panes-jsx","42":"component---src-pages-github-students-jsx","43":"component---src-pages-index-jsx","44":"component---src-pages-integrations-index-jsx","45":"component---src-pages-integrations-jetbrains-webstorm-jsx","46":"component---src-pages-integrations-markerio-jsx","47":"component---src-pages-integrations-toybox-systems-jsx","48":"component---src-pages-integrations-tumult-hype-jsx","49":"component---src-pages-integrations-tumult-whisk-jsx","50":"component---src-pages-legal-jsx","51":"component---src-pages-newsletter-jsx","52":"component---src-pages-og-screenshot-jsx","53":"component---src-pages-opener-jsx","54":"component---src-pages-portal-index-jsx","55":"component---src-pages-pricing-jsx","56":"component---src-pages-privacy-jsx","57":"component---src-pages-product-tour-jsx","58":"component---src-pages-quality-assurance-index-jsx","59":"component---src-pages-resources-jsx","60":"component---src-pages-responsive-design-glossary-jsx","61":"component---src-pages-responsive-website-test-jsx","62":"component---src-pages-screenshot-comparison-jsx","63":"component---src-pages-site-quality-index-jsx","64":"component---src-pages-social-media-previews-index-jsx","65":"component---src-pages-special-offers-jsx","66":"component---src-pages-support-index-jsx","67":"component---src-pages-syntax-jsx","68":"component---src-pages-tailwindcss-jsx","69":"component---src-pages-testimonials-jsx","70":"component---src-pages-thanks-jsx","71":"component---src-pages-visualize-browser-sizes-jsx","72":"component---src-templates-blog-list-jsx","73":"component---src-templates-doc-jsx","74":"component---src-templates-post-jsx","75":"component---src-templates-term-jsx"}[chunkId]||chunkId) + "." + {"0":"31c6beb084c9ad7b5ca0","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
